export default __webpack_public_path__ + "static/portfolio-2-86c8a9608516467663d973d953b8144e.jpg";